import { getCubaREST } from "@cuba-platform/react";
import { PositionGroupExt } from "cuba/entities/base/base$PositionGroupExt";
import { useQuery } from "react-query";

const fetchPositionGroup = async (positionGroupId: string) => {
  return getCubaREST().loadEntity<PositionGroupExt>(
    PositionGroupExt.NAME,
    positionGroupId,
    { view: "positionGroupExt.for.requisition" },
  );
};

export const usePositionGroup = (
  positionGroupId?: string,
  onSuccessCallback?: (data: PositionGroupExt) => void,
) => {
  return useQuery({
    queryKey: ["positionGroup", positionGroupId],
    queryFn: () => fetchPositionGroup(positionGroupId!),
    enabled: !!positionGroupId,
    refetchOnWindowFocus: false,
    retry: false,
    onError: (error) => {
      console.error("❌ Ошибка загрузки группы позиций:", error);
    },
    onSuccess: (data) => {
      if (onSuccessCallback) {
        onSuccessCallback(data);
      }
    },
  });
};
